import connectPayClient from '@/lib/connect-client/connect-pay-client'
import storage from '@/lib/storage'

const state = {}
const getters = {}
const mutations = {}
const actions = {
  updateCustomerName({ commit }, params) {
    connectPayClient
      .updateCustomerName(params)
      .then(response => {
        params.onSuccess()
      })
      .catch(error => {
        console.error(error)
      })
  },

  updateCustomerEmail({ commit }, params) {
    connectPayClient
      .updateCustomerEmail(params)
      .then(response => {
        params.onSuccess()
      })
      .catch(error => {
        console.error(error)
      })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
